/* Auto-generated, do not edit */
import React from 'react';

interface Props {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

function Avatar_icn_avatar6(props: Props) {
    const { size = 14, width = size, height = size, fill = '' } = props;
    return (
      <svg viewBox="0 0 24 24" fill="#27A2A8" width={ `${ width }px` } height={ `${ height }px` } ><path d="M12 22c-4.4 0-8-3.6-8-8v-2.3h2V14c0 3.3 2.7 6 6 6s6-2.7 6-6v-2.3h2V14c0 4.4-3.6 8-8 8z"/><path d="M15 20h7C22 5 16 2 12 2S2 5 2 20h7s-3-2-3-6v-1c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v1c0 4-3 6-3 6zm1-11H8c-1 0-2 .4-2.7 1 1.8-5.3 5-6 6.7-6s4.9.8 6.7 6C18 9.4 17 9 16 9z"/><path d="M19 10H5c0-3.9 3.1-7 7-7s7 3.1 7 7z" opacity=".3"/></svg>
  );
}

export default Avatar_icn_avatar6;
